import { AssociatesFiltersState, AssociatesFiltersActionTypes, READ_ASSOCIATES_FILTERS_REQUEST, READ_ASSOCIATES_FILTERS_SUCCESS, READ_ASSOCIATES_FILTERS_FAILURE } from "store/reducers/types/associates/associatesFilters";

const defaultState: AssociatesFiltersState = {
  isLoading: false,
  errorMessage: ""
};

export default function associatesFilters(state = defaultState, action: AssociatesFiltersActionTypes): AssociatesFiltersState {
  switch (action.type) {
    case READ_ASSOCIATES_FILTERS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_ASSOCIATES_FILTERS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_ASSOCIATES_FILTERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};